export type SortKey = 'recent' | 'name' | 'size' | 'type';
export type SortDir = 'asc' | 'desc';

const SORT_KEYS: ReadonlySet<SortKey> = new Set(['recent', 'name', 'size', 'type']);
const SORT_DIRS: ReadonlySet<SortDir> = new Set(['asc', 'desc']);

export function parseSort(value: string | null | undefined): SortKey {
  if (value && SORT_KEYS.has(value as SortKey)) return value as SortKey;
  return 'recent';
}

export function parseDir(value: string | null | undefined): SortDir | null {
  if (value && SORT_DIRS.has(value as SortDir)) return value as SortDir;
  return null;
}

export function defaultDirFor(sort: SortKey): SortDir {
  return sort === 'name' || sort === 'type' ? 'asc' : 'desc';
}
